import React, {Component} from 'react';
import Carousel from 'react-bootstrap/Carousel'

import '../stylesheets/HomeCarousel.css'

class HomeCarousel extends Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      index: 0,
      direction: null,
    };
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  render() {
    return (
      <Carousel
        activeIndex={this.state.index}
        direction={this.state.direction}
        onSelect={this.handleSelect}
      >
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={process.env.PUBLIC_URL + '/images/slider1.jpg'}
            alt="First slide"
            style={{objectPosition: '50% 65%', objectFit: 'cover', height: 400}}
          />
          <Carousel.Caption>
            <h1><strong>Performace Road Bike Rental</strong></h1>
            <p id="boldParagraph">Your Global Ride</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={process.env.PUBLIC_URL + '/images/slider2.jpg'}
            alt="Third slide"
            style={{objectPosition: '10% 30%', objectFit: 'cover', height: 400}}
          />

          <Carousel.Caption>
            <h2>Second slide label</h2>
            <p id="boldParagraph">Your Global Ride</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={process.env.PUBLIC_URL + '/images/slider3.jpg'}
            alt="Third slide"
            style={{objectPosition: 'center', objectFit: 'cover', height: 400}}
          />

          <Carousel.Caption>
            <h2>Third slide label</h2>
            <p id="boldParagraph">Your Global Ride</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    )
  }
}

export default HomeCarousel